/*@ngInject*/
const SystemPreferencesManagerModel = function () {

    var systemPreferences = {},
        hasUnsavedChanges = false;

    this.getSystemPreferences = function () {
        return systemPreferences;
    };

    this.setSystemPreferences = function (value) {
        systemPreferences = value;
    };

    this.setSystemPreferenceValueByName = function (name, value) {
        let systemPreference = _.find(systemPreferences, {'name': name});
        let isChange = false;
        if (!_.isNil(systemPreference)) {
            isChange = systemPreference.value !== value;
            systemPreference.value = value;
        }
        if (isChange) {
            this.setUnsavedChanges(true);
        }
    }

    this.setUnsavedChanges = function (value) {
        hasUnsavedChanges = value;
    };

    this.hasUnsavedChanges = function () {
        return hasUnsavedChanges;
    };
};

angular.module('ums.configuration')
    .service('systemPreferencesManagerModel', SystemPreferencesManagerModel);
